import { getOrdersIdPhotos } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const ORDER_PHOTOS = "ORDER_PHOTOS";

export const getOrderPhotosQueryKey = (orderId: number) => [
	ORDER_PHOTOS,
	orderId,
];

export function useOrderPhotosQuery(orderId: number) {
	return useQuery({
		queryKey: getOrderPhotosQueryKey(orderId),
		queryFn: processResponse(() => getOrdersIdPhotos(orderId)),
		retry: false,
		// Signed URLs expire after one hour — refetch well before that.
		refetchInterval: 30 * 60 * 1000,
		refetchIntervalInBackground: false,
		refetchOnWindowFocus: true,
		enabled: !!orderId,
	});
}
